import { render, staticRenderFns } from "./YourCommittee.vue?vue&type=template&id=49ff08d8"
import script from "./YourCommittee.vue?vue&type=script&lang=js"
export * from "./YourCommittee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports